import AbsensiSiswa from '../../../views/Student/absensi/AbsensiSiswa.student.view';

export default AbsensiSiswa;